import { type SubscriptionProductAccessPeriod } from "@fitness-app/data-models/entities/ProductClient";

export const SUBSCRIPTION_STATUS_MAPPER = {
  active: "success",
  paid: "success",
  imported: "success",
  past_due: "warning",
  paused: "warning",
  incomplete_expired: "warning",
  trialing: "processing",
  incomplete: "processing",
  canceled: "warning",
  unpaid: "error",
  expired: "error",
} as const;

/**
 * An installment plan whose first installment was paid upfront (prepaid raty,
 * deferred renewals — TRE-1898/TRE-1988) keeps the Stripe subscription in
 * `trialing` for the whole prepaid period. That is the intended billing state,
 * not a trial, so it gets its own label and a success badge.
 */
export const isPrepaidInstallmentsTrial = (accessPeriod: SubscriptionProductAccessPeriod) =>
  accessPeriod.status === "trialing" && (accessPeriod.installments ?? 0) > 1;
